var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showAlert)?_c('div',{staticClass:"np-alert np-alert-ani np-alert-msg",class:_vm.setAlertClass,style:(_vm.opts.style)},[_c('div',{style:(_vm.opts.contentStyle),domProps:{"innerHTML":_vm._s(_vm.msg)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }